import { render, staticRenderFns } from "./InvoiceNew_Details2.vue?vue&type=template&id=2cf8cf2c&"
import script from "./InvoiceNew_Details2.vue?vue&type=script&lang=js&"
export * from "./InvoiceNew_Details2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports